import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { request } from '../../../../services/request';
import { shouldReportErrorMonitor } from '../../Challenge/helpers/shouldReportErrorMonitor';
import { handleError } from '../../../ErrorHandler/errorHandlerPropsMap';
import { Namespace, Role } from '@wix/ambassador-legends-persona-v1-chat/types';
import { sendChatMessage } from '@wix/ambassador-legends-persona-v1-chat/http';

export default async function (
  flowAPI: ControllerFlowAPI,
  chatId: string,
  message: string,
  store: any,
  attachments?: any,
) {
  flowAPI.controllerConfig.setProps({
    messages: [
      { id: '-1', role: Role.ASSISTANT },
      { id: null, chatId, content: message, role: Role.USER },
      ...(store.messages || []),
    ],
  });

  try {
    const lastMessage = (
      await request({
        flowAPI,
        options: sendChatMessage({
          chatId,
          namespace: Namespace.EDUCATION,
          message,
        }),
        errorOptions: {
          errorCodesMap: { applicationError: {} },
        },
      })
    )?.data?.messages?.[0];

    const messages = [
      lastMessage,
      { id: null, chatId, content: message, role: Role.USER },
      ...(store.messages || []),
    ];

    store.messages = [...messages];

    flowAPI.controllerConfig.setProps({
      messages,
    });
  } catch (error) {
    const resolvedError = flowAPI.errorHandler.getResolvedError(error);

    handleError({
      error,
      resolvedError,
      context: 'SendChatMessage',
      preventErrorMonitorReport: !shouldReportErrorMonitor(error),
    });

    flowAPI.controllerConfig.setProps({
      messages: [...store.messages],
    });
  }
}
